<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <vue-snotify></vue-snotify>
    <b-row>
      <b-col lg="12">
        <div class="float-right pb-3"></div>
      </b-col>
    </b-row>
    <b-card>
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0">Publish Claim</h3>
        </b-col>
      </b-row>
   
      <b-row class="mb-6">
        <b-col lg="4">
            <!-- :disabled="generateT2TaxFileDisbleCheck" -->
          <b-button
            :disabled="false"
            class="float-right"
            @click="generateT2TaxFile()"
            block
            variant="outline-success"
            ><i class="fa-solid fa-file-csv pr-3"></i>Export Claim
            Financials</b-button
          >
          <label
            v-if="activeClaim && activeClaim.isT2TaxFileGenerated"
            class="label label-size text-muted"
            >{{ t2TaxFileGeneratedOn() }}</label
          >
        </b-col>
        <b-col lg="4">
          <!-- :disabled="taxNativeDisabledCondition" -->
          <b-button
            :disabled="false"
            block
            variant="primary"
            class="float-right"
            @click="$bvModal.show('bv-native-tax-upload-modal')"
          >
            <i class="fa-solid fa-upload"></i>
            Upload Schedules PDF</b-button
          >
          <label
            v-if="activeClaim && activeClaim.nativeTaxFileStatus"
            class="label label-size text-muted"
            >{{ nativeTaxFileGeneratedOn() }}</label
          >
        </b-col>
        <b-col lg="2"> </b-col>
        <b-col lg="2">
        </b-col>
      </b-row>

      <b-row class="justify-content-md-center">
        <b-col lg="4">
          <stats-card
            title="Client"
            type="gradient-red"
            class="mb-4 card-style"
            :class="dynamicDisableClass('CLIENT')"
          >
            <template slot="footer">
              <b-row align-v="center" slot="header">
                <b-col cols="12">
                  <!-- :disabled="
                      this.activeClaim &&
                      (this.activeClaim.clientPdfUpdateBy != null ||
                        !this.activeClaim.nativeTaxFileStatus)
                    " -->
                  <b-button
                    :disabled="false"
                    block
                    variant="warning"
                    @click="producePdf('CLIENT')"
                    ><i class="fa-regular fa-file-pdf pr-2"></i>Produce PDF for
                    Client Submission</b-button
                  >
                </b-col>
                <b-col lg="12">
                  <label v-if="activeClaim" class="label label-size text-muted">
                    {{ clientUpdateStr }}
                  </label>
                </b-col>
              </b-row>
              <!--               <b-row class="pt-4">
                <b-col lg="12">
                  <b-form-checkbox
                    class="ml-3"
                    id="checkbox-1"
                    v-model="selectedPdfType"
                    name="checkbox-1"
                    size="lg"
                    value="CLIENT"
                    unchecked-value="not_accepted"
                  >
                    Has Claim been submitted to client?
                  </b-form-checkbox>
                </b-col>
              </b-row> -->
            </template>
          </stats-card>
        </b-col>
        <b-col lg="4">
          <stats-card
            title="Accountant"
            type="gradient-red"
            class="mb-4 card-style"
            :class="dynamicDisableClass('ACCOUNTANT')"
          >
            <template slot="footer">
              <b-row align-v="center" slot="header">
                <b-col cols="12">
                  <!-- :disabled="
                      this.activeClaim &&
                      (this.activeClaim.accountantPdfUpdateBy != null ||
                        !this.activeClaim.nativeTaxFileStatus)
                    " -->
                  <b-button
                    :disabled="false"
                    block
                    variant="warning"
                    @click="producePdf('ACCOUNTANT')"
                    ><i class="fa-regular fa-file-pdf pr-2"></i>Produce PDF for
                    Accountant Submission</b-button
                  >
                </b-col>
                <b-col lg="12">
                  <label v-if="activeClaim" class="label label-size text-muted">
                    {{ accountantUpdateStr }}
                  </label>
                </b-col>
              </b-row>
              <!--           <b-row class="pt-4">
                <b-col lg="12">
                  <b-form-checkbox
                    class="ml-3"
                    id="checkbox-2"
                    v-model="selectedPdfType"
                    name="checkbox-2"
                    size="lg"
                    value="ACCOUNTANT"
                    unchecked-value="not_accepted"
                  >
                    Has Claim been submitted to Accountant?
                  </b-form-checkbox>
                </b-col>
              </b-row> -->
            </template>
          </stats-card>
        </b-col>
        <b-col
          lg="4"
          v-if="this.activeClaim && this.activeClaim.claimType != 2"
        >
          <stats-card
            title="CRA"
            type="gradient-red"
            class="mb-4 card-style"
            :class="dynamicDisableClass('CRA')"
          >
            <template slot="footer">
              <b-row align-v="center" slot="header">
                <b-col cols="12">
                  <!-- :disabled="
                      this.activeClaim &&
                      (this.activeClaim.craPdfUpdateBy != null ||
                        !this.activeClaim.nativeTaxFileStatus)
                    "                   -->
                  <b-button
                    :disabled="false"
                    block
                    variant="warning"
                    @click="producePdf('CRA')"
                    ><i class="fa-regular fa-file-pdf pr-2"></i>Produce PDF for
                    CRA Submission</b-button
                  >
                </b-col>
                <b-col lg="12">
                  <label v-if="activeClaim" class="label label-size text-muted">
                    {{ craUpdateStr }}
                  </label>
                </b-col>
              </b-row>
              <!--      <b-row class="pt-4">
                <b-col lg="12">
                  <b-form-checkbox
                    class="ml-3"
                    id="checkbox-3"
                    v-model="selectedPdfType"
                    name="checkbox-3"
                    size="lg"
                    value="CRA"
                    unchecked-value="not_accepted"
                  >
                    Has Claim been submitted to CRA?
                  </b-form-checkbox>
                </b-col>
              </b-row> -->
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </b-card>

    <!-- Start Report Link Modal -->
    <b-modal size="sm" id="modal-publish-explore-file" hide-footer>
      <template #modal-title>
        <h3>Explore File</h3>
      </template>
      <div class="text-center">
        <span class="custom-non-br-undeline">
          <b-button variant="primary" target="_blank" :href="exploreFileLink"
            >Click here to explore file</b-button
          >
        </span>
      </div>
      <div class="float-right mt-5"></div>
    </b-modal>
    <!-- End Report Link Modal -->

    <b-modal id="bv-native-tax-upload-modal" hide-footer>
      <template #modal-title>
        <h3>Upload Schedules PDF</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col lg="10">
            <div class="form-group">
              <div>
                <b-form-file
                  v-model="tax_native_file"
                  variant="primary"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                ></b-form-file>
                <b-progress
                  :value="tax_native_file_progress"
                  :max="max"
                  show-progress
                  animated
                  class="mt-2"
                  variant="warning"
                  v-if="isUploading == 1"
                  height="1.5rem"
                ></b-progress>
              </div>
            </div>
          </b-col>
          <b-col lg="2">
            <!-- :disabled="isUploading == 1" -->
            <b-button
              variant=""
              :disabled="false"
              @click="tax_native_file = null"
              ><i class="fa fa-refresh" aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-3">
        <!-- :disabled="!tax_native_file || isUploading == 1" -->
        <b-button
          variant="primary"
          @click="uploadTaxNativeFile()"
          :disabled="false"
          >Upload</b-button
        >
        <b-button
          variant=""
          @click="$bvModal.hide('bv-native-tax-upload-modal')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import mixins from "./../../mixins/common.js";
import moment from "moment";
export default {
  data() {
    return {
      status: "",
      selectedPdfType: "",
      isLoading: false,
      fullPage: true,
      clientUpdateStr: "",
      craUpdateStr: "",
      accountantUpdateStr: "",
      exploreFileLink: "",
      isUploading: 0,
      tax_native_file: null,
      value: 0,
      max: 100,
    };
  },
  watch: {
    activeClaim: function (newVal, oldVal) {
      if (this.activeClaim) {
        this.clientUpdateStr = this.updateByCsStr(
          this.activeClaim.clientPdfUpdateBy,
          this.activeClaim.clientPdfUpdatedOn
        );
        this.accountantUpdateStr = this.updateByTrStr(
          this.activeClaim.accountantPdfUpdateBy,
          this.activeClaim.accountantPdfUpdatedOn
        );
        this.craUpdateStr = this.updateByTrStr(
          this.activeClaim.craPdfUpdateBy,
          this.activeClaim.craPdfUpdatedOn
        );
      }
    },
  },
  mixins: [mixins],
  computed: {
    claim: {
      get() {
        return this.$store.state.claim;
      },
      set(val) {
        this.$store.state.claim = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
    internal_review_class: {
      get() {
        return this.$store.state.internal_review_class;
      },
      set(val) {
        this.$store.state.internal_review_class = val;
      },
    },
    generateT2TaxFileDisbleCheck() {
      let disableCheck = false;
      if (
        (this.activeClaim && !this.activeClaim.isFinancialExtracted) ||
        (this.activeClaim && this.activeClaim.internalReviewStatus == 5)
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },
    taxNativeDisabledCondition() {
      let disableCheck = false;
      if (this.activeClaim && this.activeClaim.internalReviewStatus == 5) {
        disableCheck = true;
      }
      return disableCheck;
    },
    tax_native_file_progress: {
      get() {
        return this.$store.state.admin.tax_native_file_progress;
      },
      set(val) {
        this.$store.state.admin.tax_native_file_progress = val;
      },
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
  },
  methods: {
    ...mapActions("admin", [
      "produceMergedPdf",
      "getClaimRecordById",
      "getExploreFileLink",
      "generateT2TaxFileData",
      "uploadTaxProgramNativeFile",
      "updateClaimStatusWhenPublish",
    ]),
    dynamicDisableClass(type) {
      let disabled = "";
      /* if (type == "CLIENT") {
        if (this.activeClaim && this.activeClaim.clientPdfUpdateBy != null) {
          disabled = "disabled-card";
        }
      } else if (type == "ACCOUNTANT") {
        if (
          this.activeClaim &&
          this.activeClaim.accountantPdfUpdateBy != null
        ) {
          disabled = "disabled-card";
        }
      } else if (type == "CRA") {
        if (this.activeClaim && this.activeClaim.craPdfUpdateBy != null) {
          disabled = "disabled-card";
        }
      } */
      return disabled;
    },
    viewExploreFileLink() {
      this.exploreFileLink = "";
      this.isLoading = true;
      let claimdata = {
        claim_id: this.claim,
      };
      this.getExploreFileLink(claimdata).then((data) => {
        if (data.data.errors) {
          this.$snotify
            .error("Publish Claim issue - Document Not Found", "Error!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
        } else {
          if (
            data.data &&
            data.data.message &&
            this.validSharePointURL(data.data.message)
          ) {
            //window.open(data.data.message);
            this.exploreFileLink = data.data.message;
            this.$bvModal.show("modal-publish-explore-file");
          } else {
            this.$snotify
              .error("Publish Claim validation issue - Document Not Found", "Error!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
          }
        }
        this.isLoading = false;
      });
    },
    refreshClaimSpecificData() {
      let claimParams = {
        claim_id: this.claim,
      };
      if (this.claim) {
        this.getClaimRecordById(claimParams).then((data) => {
          if (data && data.data) {
            this.clientUpdateStr = this.updateByCsStr(
              data.data.clientPdfUpdateBy,
              data.data.clientPdfUpdatedOn
            );
            this.accountantUpdateStr = this.updateByTrStr(
              data.data.accountantPdfUpdateBy,
              data.data.accountantPdfUpdatedOn
            );
            this.craUpdateStr = this.updateByTrStr(
              data.data.craPdfUpdateBy,
              data.data.craPdfUpdatedOn
            );

            this.activeClaim.clientPdfUpdateBy = data.data.clientPdfUpdateBy;
            this.activeClaim.craPdfUpdateBy = data.data.craPdfUpdateBy;
            this.activeClaim.accountantPdfUpdateBy =
              data.data.accountantPdfUpdateBy;
            this.activeClaim.internalReviewStatus =
              data.data.internalReviewStatus;
            this.internal_review_class = this.internalReviewClassStr(
              data.data.internalReviewStatus
            );
          } else {
          }
        });
      }
    },
    producePdf(type) {
      this.isLoading = true;
      let dataParams = {
        claimId: this.claim,
        type: type,
      };
      this.produceMergedPdf(dataParams).then((data) => {
        if (data.data.errors) {
          this.isLoading = false;
        } else {
          if (data.data && data.data.success) {
            var incrementCount = 1;
            this.activeClaim.internalReviewStatus = 5;
            this.selectedPdfType = "";
            this.$snotify.clear();
            this.$snotify
              .success(data.data.success.message, "Success!", {
                position: "centerTop",
              })
              .on("destroyed", () => {
                //tempary fix for call multiple hooks
                if(incrementCount == 1){
                  this.refreshClaimSpecificData();
                  this.updateClaimStatusPdfPublish();
                }
                incrementCount ++;
              });
          }
        }
      });
    },
    updateClaimStatusPdfPublish() {
      if (this.activeClaim.claimStatus == 3) {
        let params = {
          claim_id: this.claim,
        };
        this.updateClaimStatusWhenPublish(params).then((data) => {
          this.isLoading = false;
          if (data.data && data.data.success) {
            if (data.data.success.claimStatus) {
              this.activeClaim.claimStatus = data.data.success.claimStatus;
            }
          }
        });
      }else{
        this.isLoading = false;
      }
    },
    generateT2TaxFile() {
      this.isLoading = true;
      let financeParams = {
        claim_id: this.claim,
      };
      this.generateT2TaxFileData(financeParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.$snotify
            .success(data.data.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
          this.activeClaim.isT2TaxFileGenerated = true;

          this.activeClaim.t2TaxFileGeneratedOn = moment();
        }
        this.isLoading = false;
      });
    },
    uploadTaxNativeFile() {
      let formData = new FormData();
      formData.append("myFile", this.tax_native_file);
      formData.append("claim_id", this.claim);
      this.isUploading = 1;
      this.uploadTaxProgramNativeFile(formData).then((data) => {
        if (data.data.success) {
          this.activeClaim.nativeTaxFileStatus = true;
          this.activeClaim.nativeTaxFileUploadeddOn = moment();

          this.$snotify
            .success(data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
          this.$bvModal.hide("bv-native-tax-upload-modal");
        } else {
          this.$bvModal.hide("bv-native-tax-upload-modal");
        }
        this.isUploading = 0;
        this.tax_native_file_progress = 0;
      });
    },
    t2TaxFileGeneratedOn() {
      if (this.activeClaim && this.activeClaim.t2TaxFileGeneratedOn) {
        return (
          "File Generated : " +
          moment
            .utc(this.activeClaim.t2TaxFileGeneratedOn)
            .local()
            .format("YYYY-MM-DD H:m")
        );
      }
    },
    nativeTaxFileGeneratedOn() {
      if (this.activeClaim && this.activeClaim.nativeTaxFileUploadeddOn) {
        return (
          "File Generated : " +
          moment
            .utc(this.activeClaim.nativeTaxFileUploadeddOn)
            .local()
            .format("YYYY-MM-DD H:m")
        );
      }
    },
  },
};
</script>

<style scoped>
.card-style {
  -webkit-box-shadow: 0 6px 16px rgb(52 105 203 / 16%);
  box-shadow: 0 6px 16px rgb(52 105 203 / 16%);
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.label-size {
  font-size: 0.7rem;
  font-weight: 300;
  line-height: 1.7;
}

.disabled-card {
  pointer-events: none;
  background-color: #ececec;
}

/* .card-style:hover {
    -webkit-box-shadow: 0 6px 16px rgb(52 105 203 / 26%);
    box-shadow: 0 6px 16px rgb(52 105 203 / 26%);
} */
</style>
